/*
 * @Author: Enzo
 * @Date: 2021-07-13 10:35:00
 * @LastEditTime: 2021-07-20 17:49:28
 * @LastEditors: Enzo
 * @Description:
 * @FilePath: /waimai_cd_fe_greentech_c/src/assets/apis/base.js
 * God is watching you
 */
import ax from 'axios';
import { get, axios, post } from '../../utils/http';

const axo = ax.create({ baseURL: '' });

// 各类基金类型
export const ProjectTypeEnums = {
  // 美团青山科技奖
  SciType: 1,
  InoType: 2,
};
// 上传文件获取签名
export const getS3Token = (data) => get('/file/getS3Token', data);

// 文件预览
export const getS3DownloadUrl = (data) => get('/file/getS3DownloadUrl', data);

// 文件打开预览链接
export const getS3PreviewUrl = (data) => get('/file/getPreviewUrl', data);

// 用户信息
export const getUserData2 = (d) => get('user/getUserInfo', d);
// 用户信息
export const getUserData = () => axios.get('user/getUserInfo', { withCredentials: true }, { dontPanic: true }).then((res) => res.data);
// 获取用户协议
export const getUserAgreement = (data) => post('/user/getUserAgreement', data, { dontPanic: true });

// 签署用户协议
export const signUserAgreement = (data) => post('/user/signUserAgreement', data);

// 获取时间配置
export const getConf = (data) => get('/conf/getConf', data, { dontPanic: true });

export const getApplyPeriodFlag = (data) => post('/apply/conf', data);

/* 获取当前时间戳-无需登录 */
export const getTimestamp = (data) => get('/common/now', data);
// 获取文件下载url
export const getFileDownloadUrl = (data) => get('/file/getS3DownloadUrl', data);

// 获取文章列表
export function getArticles() {
  return axo.get(`/horn/v1/modules/list${window.location.href.includes('.test.') ? '?os=android_test' : ''}`).then((res) => Array.from(Object.values(res?.data || {})).filter((t) => t.url && t.title && t.img && t.time && t.status === 'on'));
}
export const getArticlesV2 = () => get('/trend/list');
// 获取章程/指南/faq等数据
export function getApplyFiles() {
  return axo.get(`/horn/v1/modules/apply_file${window.location.href.includes('.test.') ? '?os=android_test' : ''}`).then((res) => res.data || {});
}

// 获取提名详情
export const getNominationDetail = (data) => get('/nomination/detail', data);
// 上传提名信
export const postNomination = (data) => post('/nomination/save', data);
// 上传推荐信
export const postRecommend = (data) => post('/recommend/save', data);

// 获取关于上传推荐信的信息-上传过的推荐信、推荐截止时间
export const getRecommendInfo = (data) => get('/recommend/getRecommend', data);
// export const getRecommendInfo = (data) => get('http://127.0.0.1:4523/m1/1865970-0-default/test', data);
